// extracted by mini-css-extract-plugin
export var modal = "_jc-0";